var _circle, _text;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_197",
    "data-name": "Group 197",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.815,
    height: 29.815,
    viewBox: "0 0 29.815 29.815",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 14.908,
    cy: 14.908,
    r: 14.908,
    fill: "#e3001920"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_",
    "data-name": "$",
    transform: "translate(8.131 21.71)",
    fill: "#e30019",
    fontSize: 20,
    fontFamily: "Graphie-Regular, Graphie"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "$"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsd);
export default __webpack_public_path__ + "static/media/usd.c519b6726ed36d7350deea53c7dd5188.svg";
export { ForwardRef as ReactComponent };